import React from 'react';
import {StockStatusBase} from "./StockStatusBase";

export const StockStatusEN = () => {
    const translations = {
        lastProduct: 'Last product in stock',
        stockStatuses: {
            'In stoc': 'In stock',
            'Stoc limitat': 'Limited stock',
            'La comanda': 'On order',
            'La furnizor': 'At supplier',
            'In stoc furnizor': 'In supplier stock',
            'Stoc extern cu livrare rapida': 'External stock with fast delivery',
            'Rezervat': 'Reserved'
        }
    };

    const getStockValue = (status: string) => {
        switch (status) {
            case 'In stock':
                return 'We have more than 5 pieces in stock.';
            case 'Limited stock':
                return 'We have less than 5 pieces in stock.';
            case 'Last product in stock':
                return 'The product is in the physical stock of the Store.';
            case 'On order':
            case 'At supplier':
            case 'In supplier stock':
            case 'External stock with fast delivery':
                return 'The product is not available in Store stock, but it might be available in the supplier\'s warehouse. ' +
                    'If you register an order for this product, one of our sales consultants will check ' +
                    'the product availability at the supplier and will contact you as soon as possible.';
            case 'Reserved':
                return 'The product is in the physical stock of the Store, but appears reserved for a customer. ' +
                    'If you are interested, please contact us to check if the reservation on this product is still current or not.';
            default:
                return '';
        }
    }

    return <StockStatusBase getStockValue={getStockValue} translations={translations}/>;
}
